import { Plus } from 'lucide-react';
import React from 'react';
import { Button, Tooltip, FormDrawer } from '../../ui';
import FormUser from '../Forms/FormUser';

export default function AddUser(props: { handleFunction: any }) {
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        props.handleFunction()
        setOpen(false);
    };

    return (
        <div>
            <Tooltip title="Ajouter un nouvel utilisateur">
                <Button
                    size='sm'
                    style={{ float: "right" }}
                    variant="primary"
                    startIcon={<Plus size={16} />}
                    onClick={() => setOpen(true)}
                >Ajouter</Button>
            </Tooltip>
            <FormDrawer
                open={open}
                onClose={handleClose}
                title="Ajout d'un utilisateur"
                hint="Renseignez les informations du nouvel utilisateur. Un mot de passe provisoire lui sera communiqué."
            >
                <FormUser />
            </FormDrawer>
        </div>
    );
}
